<template>
  <div class="main-body">
    <div class="header">社区食堂订单</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     @change="govChange"
                     style="margin-right:10px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-select size="mini" v-model="businessCode"
                     placeholder="请选择商家" style="margin-right:10px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.name"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" plain @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>
        <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>
        <el-table-column prop="user.phone" label="老人手机号" width="150"></el-table-column>


        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>



        <el-table-column prop="price" label="总价" width="105"></el-table-column>

        <el-table-column width="105" label="订单来源" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderFrom =='pc'">商家预工单</div>
            <div v-if="scope.row.orderFrom =='android' ">长者端</div>
            <div v-if="scope.row.orderFrom =='table' ">收银机</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType ==2 ">单独服务</div>
            <div v-if="scope.row.orderType ==3 ">合并服务</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="付款类型" >
          <template slot-scope="scope">
            <!--            <span>{{scope.row.payType}}</span>-->
            <div v-if="scope.row.payType == 'wx' ">微信</div>
            <div v-if="scope.row.payType == 'ali' ">支付宝</div>
            <div v-if="scope.row.payType == 'yue' ">余额</div>
            <div v-if="scope.row.payType == 'cash' ">现金</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="105" label="删除">
          <template slot-scope="scope">
            <span v-if="scope.row.isDelete == 1">已删除</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="下单时间"></el-table-column>
        <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
        <el-table-column prop="payTime" :formatter="timefilter" width="200" label="付款时间"></el-table-column>
        <el-table-column prop="completeTime" :formatter="timefilter" width="200" label="完成时间"></el-table-column>


        <el-table-column prop="order.receiveName" width="100" label="收货人"></el-table-column>
        <el-table-column prop="order.receivePhone" width="120" label="收货人手机"></el-table-column>
        <el-table-column prop="order.receiveAreaPath" width="200" label="收货人地区"></el-table-column>
        <el-table-column prop="order.receiveAddress" width="200" label="收货人地址"></el-table-column>


        <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>
        <el-table-column prop="orderServe.startTime" :formatter="timefilter" width="200" label="服务开始时间"></el-table-column>
        <el-table-column prop="orderServe.endTime" :formatter="timefilter" width="200" label="服务结束时间"></el-table-column>

        <el-table-column width="120" label="开始服务备注">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOStart !=null ">
              {{scope.row.orderServeRecordDTOStart.remark}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="开始服务图片">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOStart !=null ">
              <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.orderServeRecordDTOStart.listOrderServeRecordImg" :key="index">
                <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" label="结束服务备注">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOEnd !=null ">
              {{scope.row.orderServeRecordDTOEnd.remark}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="结束服务图片">
          <template slot-scope="scope">
            <div v-if="scope.row.orderServeRecordDTOEnd !=null ">
              <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.orderServeRecordDTOEnd.listOrderServeRecordImg" :key="index">
                <img :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width: 500px"/>
                <img slot="reference" :src="imgUrl+item.imgPath+'_watermark.jpg'" style="width:60px">
              </el-popover>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data() {
    return {


      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,



      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,



      arr_business:[],
      businessCode:'',

      governmentValue: [],
      governmentCode: '',

    }
  },
  components: {

  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      this.getGovList();
    },

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getBusiness();
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    govChange(val){
      this.governmentCode = val;
      this.arr_business = [];
      this.businessCode = '';
      this.getBusiness();
    },


    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          businessType:3,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_business = response.data.data;
          if(this.arr_business.length>0){
            this.businessCode = this.arr_business[0].businessCode;
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },





    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },




    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true


      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        governmentCode: this.governmentCode,
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        businessCode:this.businessCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessAdm/AdmPageForElderlyOrder",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },





  }
}
</script>


<style lang="scss" scoped>

</style>
